
export enum BrokingFeeChargeEvent {
    Sale = 1,
    Transfer = 2,
    SaleAndTransfer = 3,
}